/**
 * Resolves the SignalR hub URL. Prefer REACT_APP_SIGNALR_HUB_URL, then derive from FILE_URL or API_URL.
 */
function getSignalRHubUrl(): string {
	const trimEnv = (v: string | undefined) =>
		v?.replace(/^["'\s]+|["'\s]+$/g, '').trim() ?? '';

	const explicit = trimEnv(process.env.REACT_APP_SIGNALR_HUB_URL);
	if (explicit) return explicit;

	const fileUrl = trimEnv(process.env.REACT_APP_FILE_URL).replace(/\/$/, '');
	if (fileUrl) return `${fileUrl}/hubs/bo-realtime`;

	const apiUrl = trimEnv(process.env.REACT_APP_API_URL);
	if (apiUrl) {
		const base = apiUrl.replace(/\/api\/?$/i, '').replace(/\/$/, '');
		if (base) return `${base}/hubs/bo-realtime`;
	}

	return '/hubs/bo-realtime';
}

export default getSignalRHubUrl;
